/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';

import { CartPageLayoutHandler } from '@spartacus/cart/base/components';
import { Cart } from '@spartacus/cart/base/root';
import { combineLatest, Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Injectable()
export class DpCartPageLayoutHandler extends CartPageLayoutHandler {
  handle(slots$: Observable<string[]>, pageTemplate?: string, section?: string): Observable<string[]> {
    if (pageTemplate === 'CartPageTemplate' && !section) {
      return combineLatest([slots$, this.activeCartService.getActive(), this.getSelectiveCart()]).pipe(
        map(([slots, cart, selectiveCart]) => {
          const exclude = (arr: string[], args: string[]): string[] =>
            arr.filter((item) => args.every((arg) => arg !== item));
          return cart.totalItems
            ? exclude(slots, ['EmptyCartMiddleContent'])
            : selectiveCart?.totalItems
              ? exclude(slots, ['EmptyCartMiddleContent', 'CenterRightContentSlot'])
              : exclude(slots, ['EmptyCartMiddleContent']);
        })
      );
    }
    return slots$;
  }

  protected getSelectiveCart(): Observable<Cart | null> {
    return this.cartConfig.isSelectiveCartEnabled()
      ? this.selectiveCartService.getCart().pipe(startWith(null))
      : of({} as Cart);
  }
}
